import axios from "axios";
import React, { useEffect, useState } from "react";
import { APIURL } from "../../../Config";
import { Formik, Form, Field, ErrorMessage } from "formik";
import * as Yup from "yup";
import { toast } from "react-toastify";

function Admin({ props }) {
  const emailid = localStorage.getItem("corpadminmail");
  const cid = localStorage.getItem("corporateId");
  const [listAdmin, setListAdmin] = useState([]);
  const [owner, setOwner] = useState([]);
  const [addAdmin, setAddAdmin] = useState(false);
  const [openAdmin, setOpenAdmin] = useState(0);
  const [openAssignOwner, setOpenAssignOwner] = useState(0);
  const [assignOwner, setAssignOwner] = useState(false);

  const [workSpace, setWorkSpace] = useState([]);
  const [isLoader, setIsLoader] = useState(false);
  const workspaceId = localStorage.getItem("workspace");
  const token = localStorage.getItem("token");

  console.log("email", emailid);
  console.log("corpo email:::::: ", workSpace.corpadminmail);
  const openAddAdmin = (value) => {
    setAddAdmin(true);
    setOpenAdmin(value);
  };
  const openAddAssignOwner = (value) => {
    setAssignOwner(true);
    setOpenAssignOwner(value);
  };
  const Schema = Yup.object().shape({
    email: Yup.string()
      .email("Invalid email address")
      .required("Email is required"),
    name: Yup.string().required("required"),
    mobile: Yup.string()
      .required("Required")
      .matches(/^\d{10}$/, "Mobile number must be exactly 10 digits"),
    status: Yup.string().required("Please select an option"),
  });

  useEffect(() => {
    getAccountList();
    WorkspaceDetails();
  }, [emailid]);

  function WorkspaceDetails() {
    const data = { emailid, workspaceId };
    setIsLoader(true);
    axios
      .request(`${APIURL}/corporate/getprofiledetails`, {
        method: "POST",
        data: data,
        headers: {
          Authentication: token,
          "Content-Type": "application/json",
        },
      })
      .then((response) => {
        console.log("response:::::::", response);
        setIsLoader(false);
        setWorkSpace(response?.data);
      })
      .catch((error) => {
        setIsLoader(false);
        console.log(error);
      });
  }

  const getAccountList = () => {
    setIsLoader(true);
    axios
      .request(`${APIURL}/listadminAccount/${emailid}`, {
        method: "GET",
        headers: {
          Authentication: token,
          "Content-Type": "application/json",
        },
      })
      .then((response) => {
        console.log("response:::::::", response);
        setIsLoader(false);
        setListAdmin(response?.data);
      })
      .catch((error) => {
        setIsLoader(false);
        console.log(error);
      });
  };

  const initialValues = {
    corporateId: cid,
    emailid: "",
    name: "",
    mobile: "",
  };
  const ownerSchema = Yup.object().shape({
    emailid: Yup.string()
      .email("Invalid email address")
      .required("Email is required"),
    name: Yup.string().required("required"),
    mobile: Yup.string()
      .required("Required")
      .matches(/^\d{10}$/, "Mobile number must be exactly 10 digits"),
  });

  if (isLoader) {
    return (
      <div className="text-center">
        <div className="spinner-border text-success" role="status">
          <span className="sr-only">Loading...</span>
        </div>
      </div>
    );
  }

  return (
    <div className="p-md-3 pt-3">
      <div>
        <ul className="nav nav-tabs" id="myTabs" role="tablist">
          <li className="nav-item" role="presentation">
            <button
              className="nav-link tab-item"
              id="owner-tab"
              data-bs-toggle="tab"
              data-bs-target="#owner"
              type="button"
              role="tab"
              aria-controls="owner"
              aria-selected="true"
            >
              Owner
            </button>
          </li>
          <li className="nav-item" role="presentation">
            <button
              className="nav-link active tab-item"
              id="profile-tab"
              data-bs-toggle="tab"
              data-bs-target="#profile"
              type="button"
              role="tab"
              aria-controls="profile"
              aria-selected="true"
            >
              Employer Workspace Admin
            </button>
          </li>
        </ul>
        <div className="tab-content mt-3" id="myTabsContent">
          <div
            className="tab-pane fade show active"
            id="profile"
            role="tabpanel"
            aria-labelledby="profile-tab"
          >
            <div className="pt-3">
              <div className="card">
                {!workSpace?.assuranceTc ? (
                  <p
                    className="m-0 text-center p-3"
                    style={{
                      color: "red",
                      fontSize: "22px",
                    }}
                  >
                    No Access{" "}
                  </p>
                ) : (
                  <div className="p-3 pt-4">
                    <div className="d-flex justify-content-end align-items-center">
                      {!addAdmin && workSpace.type !== "Employer_Admin" ? (
                        <button
                          className="btn btn-success mb-3 mb-md-0"
                          style={{ width: "120px", backgroundColor: "#66a725" }}
                          onClick={() => openAddAdmin(1)}
                        >
                          Add Admin
                        </button>
                      ) : (
                        <button
                          className="btn btn-secondary mb-3 mb-md-0"
                          style={{ width: "120px" }}
                          onClick={() => {
                            getAccountList();
                            setAddAdmin(false);
                          }}
                        >
                          Back
                        </button>
                      )}
                    </div>

                    {addAdmin ? (
                      <Formik
                        initialValues={{
                          email: listAdmin?.email || "",
                          name: listAdmin?.name || "",
                          mobile: listAdmin?.mobile || "",
                          status: listAdmin?.status || "Active",
                        }}
                        validationSchema={Schema}
                        onSubmit={(values, { resetForm }) => {
                          console.log("values", values);
                          const data = {
                            ...values,
                            ownerEmail: props?.email,
                            type: "Employer_Admin",
                          };

                          if (openAdmin === 1) {
                            setIsLoader(true);
                            axios
                              .post(`${APIURL}/addadmin`, data, {
                                headers: { "Content-Type": "application/json" },
                              })
                              .then((response) => {
                                console.log("response", response);
                                if (
                                  response?.data?.message ===
                                  "An Account already exists with this email Id. Please provide a new Email Id"
                                ) {
                                  toast.warning(response?.data?.message);
                                  setIsLoader(false);
                                } else {
                                  toast.success(response?.data?.message);
                                  setIsLoader(false);
                                  getAccountList();
                                  setAddAdmin(false);
                                  resetForm();
                                }
                              })
                              .catch((error) => {
                                setIsLoader(false);
                                console.log(error);
                                resetForm();
                              });
                          }

                          if (openAdmin === 2) {
                            setIsLoader(true);
                            axios
                              .post(`${APIURL}/updateadmin`, data, {
                                headers: { "Content-Type": "application/json" },
                              })
                              .then((response) => {
                                console.log("response", response);
                                setIsLoader(false);
                                getAccountList();
                                toast.success(response?.data?.message);
                                setAddAdmin(false);
                                resetForm();
                              })
                              .catch((error) => {
                                setIsLoader(false);
                                console.log(error);
                                resetForm();
                              });
                          }
                        }}
                      >
                        {({ touched, errors }) => (
                          <Form className="">
                            <div>
                              <div>
                                <div className="">
                                  <label>Email*</label>
                                  <Field
                                    type="email"
                                    name="email"
                                    placeholder="Enter email"
                                    className={`form-control ${
                                      touched.email && errors.email
                                        ? "is-invalid"
                                        : ""
                                    }`}
                                    disabled={openAdmin === 2}
                                  />
                                  <ErrorMessage
                                    component="div"
                                    name="email"
                                    className="invalid-feedback"
                                  />
                                </div>

                                <div className="mt-2">
                                  <label>Name*</label>
                                  <Field
                                    type="text"
                                    name="name"
                                    placeholder="Enter name"
                                    className={`form-control ${
                                      touched.name && errors.name
                                        ? "is-invalid"
                                        : ""
                                    }`}
                                    disabled={openAdmin === 2}
                                  />
                                  <ErrorMessage
                                    component="div"
                                    name="name"
                                    className="invalid-feedback"
                                  />
                                </div>
                                <div className="mt-2">
                                  <label>Mobile*</label>
                                  <Field
                                    type="text"
                                    name="mobile"
                                    placeholder="Enter mobile"
                                    className={`form-control ${
                                      touched.mobile && errors.mobile
                                        ? "is-invalid"
                                        : ""
                                    }`}
                                    disabled={openAdmin === 2}
                                  />
                                  <ErrorMessage
                                    component="div"
                                    name="mobile"
                                    className="invalid-feedback"
                                  />
                                </div>

                                <div className="mt-2">
                                  <label>Status*</label>
                                  <Field
                                    as="select"
                                    name="status"
                                    placeholder="Enter status"
                                    className={`form-control ${
                                      touched.status && errors.status
                                        ? "is-invalid"
                                        : ""
                                    }`}
                                  >
                                    <option value="">Select..</option>
                                    <option value="Active">Active</option>
                                    <option value="Deactive">Deactive</option>
                                  </Field>
                                  <ErrorMessage
                                    component="div"
                                    name="status"
                                    className="invalid-feedback"
                                  />
                                </div>

                                <button
                                  className="btn btn-success mt-3 border"
                                  type="submit"
                                  style={{ backgroundColor: "#66a725" }}
                                >
                                  {isLoader ? (
                                    <div
                                      className="spinner-border text-success"
                                      role="status"
                                    >
                                      <span className="sr-only">
                                        Loading...
                                      </span>
                                    </div>
                                  ) : (
                                    "Submit"
                                  )}
                                </button>
                              </div>
                            </div>
                          </Form>
                        )}
                      </Formik>
                    ) : isLoader ? (
                      <div className="d-flex justify-content-center">
                        <div
                          className="spinner-border text-success"
                          role="status"
                        >
                          <span className="sr-only">Loading...</span>
                        </div>
                      </div>
                    ) : (
                      <div className="table-responsive">
                        <table className="table table-striped mt-3">
                          <thead>
                            <tr>
                              <th style={{ textAlign: "center" }}>Sr. No</th>
                              <th style={{ textAlign: "center" }}>Name</th>
                              <th style={{ textAlign: "center" }}>Email</th>
                              {workSpace.type !== "Employer_Admin" && (
                                <th style={{ textAlign: "center" }}>Status</th>
                              )}
                            </tr>
                          </thead>
                          <tbody>
                            {listAdmin?.length > 0 &&
                              listAdmin?.map((item, i) => (
                                <tr key={i}>
                                  <td>{i + 1}</td>
                                  <td>{item?.name}</td>
                                  <td>{item?.email}</td>
                                  {workSpace.type !== "Employer_Admin" && (
                                    <td style={{ width: "120px" }}>
                                      <div className="d-flex">
                                        <button
                                          style={{
                                            backgroundColor:
                                              item?.status === "Active"
                                                ? "#28a745"
                                                : "#f8f9fa",
                                            color:
                                              item?.status === "Active"
                                                ? "white"
                                                : "#6c757d",
                                            border: "1px solid #ced4da",
                                            padding: "0.375rem 0.75rem",
                                            borderRadius: "0.25rem",
                                            cursor:
                                              item?.status === "Active"
                                                ? "not-allowed"
                                                : "pointer",
                                            transition: "all 0.2s ease",
                                            marginRight: "0.5rem",
                                          }}
                                          onMouseOver={(e) => {
                                            if (item?.status !== "Active") {
                                              e.target.style.backgroundColor =
                                                "#28a745";
                                              e.target.style.color = "white";
                                            }
                                          }}
                                          onMouseOut={(e) => {
                                            if (item?.status !== "Active") {
                                              e.target.style.backgroundColor =
                                                "#f8f9fa";
                                              e.target.style.color = "#6c757d";
                                            }
                                          }}
                                          disabled={item?.status === "Active"}
                                          onClick={() => {
                                            if (item?.status !== "Active") {
                                              setListAdmin(item);
                                              setAddAdmin(true);
                                              setOpenAdmin(2);
                                            }
                                          }}
                                        >
                                          Active
                                        </button>
                                        <button
                                          style={{
                                            backgroundColor:
                                              item?.status === "Deactive"
                                                ? "#dc3545"
                                                : "#f8f9fa",
                                            color:
                                              item?.status === "Deactive"
                                                ? "white"
                                                : "#6c757d",
                                            border: "1px solid #ced4da",
                                            padding: "0.375rem 0.75rem",
                                            borderRadius: "0.25rem",
                                            cursor:
                                              item?.status === "Deactive"
                                                ? "not-allowed"
                                                : "pointer",
                                            transition: "all 0.2s ease",
                                          }}
                                          onMouseOver={(e) => {
                                            if (item?.status !== "Deactive") {
                                              e.target.style.backgroundColor =
                                                "#dc3545";
                                              e.target.style.color = "white";
                                            }
                                          }}
                                          onMouseOut={(e) => {
                                            if (item?.status !== "Deactive") {
                                              e.target.style.backgroundColor =
                                                "#f8f9fa";
                                              e.target.style.color = "#6c757d";
                                            }
                                          }}
                                          disabled={item?.status === "Deactive"}
                                          onClick={() => {
                                            if (item?.status !== "Deactive") {
                                              setListAdmin(item);
                                              setAddAdmin(true);
                                              setOpenAdmin(2);
                                            }
                                          }}
                                        >
                                          Deactive
                                        </button>
                                      </div>
                                    </td>
                                  )}
                                </tr>
                              ))}
                          </tbody>
                        </table>
                      </div>
                    )}
                  </div>
                )}
              </div>
            </div>
          </div>
          <div
            className="tab-pane fade"
            id="owner"
            role="tabpanel"
            aria-labelledby="owner-tab"
          >
            {" "}
            <div className="card">
              <div className="pt-1">
                <div className="d-flex flex-column flex-md-row justify-content-between align-items-center">
                  <div className="p-3 pt-4">
                    <h6>Email id:&nbsp;{emailid}</h6>
                  </div>
                  {workSpace?.assuranceTc && (
                    <div className="d-flex justify-content-end align-items-center">
                      {!assignOwner && workSpace.type !== "Employer_Admin" ? (
                        <button
                          className="btn btn-success mb-3 mb-md-0 mr-2 w-auto"
                          style={{ width: "120px", backgroundColor: "#66a725" }}
                          onClick={() => openAddAssignOwner(1)}
                        >
                          Assign New Owner
                        </button>
                      ) : (
                        <button
                          className="btn btn-secondary mb-3 mb-md-0 mr-2 w-auto"
                          style={{ width: "120px" }}
                          onClick={() => {
                            // getAccountList();
                            setAssignOwner(false);
                          }}
                        >
                          Back
                        </button>
                      )}
                    </div>
                  )}
                </div>
              </div>
              {assignOwner ? (
                <div className="p-3">
                  <Formik
                    initialValues={initialValues}
                    validationSchema={ownerSchema}
                    onSubmit={(values, { resetForm }) => {
                      console.log("values", values);
                      const data = {
                        ...values,
                        type: "Employer_Admin",
                        ownerEmail: props?.email,
                      };

                      axios
                        .request(`${APIURL}/corporate/employerownership`, {
                          method: "POST",
                          data: data,
                          headers: {
                            Authentication: token,
                            "Content-Type": "application/json",
                          },
                        })
                        .then((response) => {
                          console.log("response:::", response);
                          toast.success(response.data);
                          setIsLoader(false);
                          resetForm();
                        })
                        .catch((error) => {
                          setIsLoader(false);
                          console.log(error);
                          resetForm();
                        });
                    }}
                  >
                    {({ touched, errors }) => (
                      <Form className="">
                        <div>
                          <div>
                            <div className="">
                              <label>Email*</label>
                              <Field
                                type="email"
                                name="emailid"
                                placeholder="Enter email"
                                className={`form-control ${
                                  touched.emailid && errors.emailid
                                    ? "is-invalid"
                                    : ""
                                }`}
                              />
                              <ErrorMessage
                                component="div"
                                name="emailid"
                                className="invalid-feedback"
                              />
                            </div>

                            <div className="mt-2">
                              <label>Name*</label>
                              <Field
                                type="text"
                                name="name"
                                placeholder="Enter name"
                                className={`form-control ${
                                  touched.name && errors.name
                                    ? "is-invalid"
                                    : ""
                                }`}
                              />
                              <ErrorMessage
                                component="div"
                                name="name"
                                className="invalid-feedback"
                              />
                            </div>

                            <div className="mt-2">
                              <label>Mobile*</label>
                              <Field
                                type="number"
                                name="mobile"
                                placeholder="Enter Mobile no"
                                className={`form-control ${
                                  touched.mobile && errors.mobile
                                    ? "is-invalid"
                                    : ""
                                }`}
                              ></Field>
                              <ErrorMessage
                                component="div"
                                name="mobile"
                                className="invalid-feedback"
                              />
                            </div>

                            <button
                              className="btn btn-success mt-3 border"
                              type="submit"
                              style={{ backgroundColor: "#66a725" }}
                            >
                              {isLoader ? (
                                <div
                                  className="spinner-border text-success"
                                  role="status"
                                >
                                  <span className="sr-only">Loading...</span>
                                </div>
                              ) : (
                                "Submit"
                              )}
                            </button>
                          </div>
                        </div>
                      </Form>
                    )}
                  </Formik>
                </div>
              ) : isLoader ? (
                <div className="d-flex justify-content-center">
                  <div className="spinner-border text-success" role="status">
                    <span className="sr-only">Loading...</span>
                  </div>
                </div>
              ) : (
                ""
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Admin;
